import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useCompaniesAiCost = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();

    const [companiesCostData, setCompaniesCostData] = useState([]);
    const [totalCostCount, setTotalCostCount] = useState(0);

    useEffect(() => {
        const fetchCompanies = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies });
            try {
                const response = await getData(`${baseUrl.companyAiCost}?${query}`);
                if (response?.success) {
                    setCompaniesCostData(response?.data?.totalCost || []);
                    setTotalCostCount(response?.data?.overallCompaniesTotalCost || 0);
                }
            } catch (err) {
                console.error("Failed to fetch companies cost data", err);
                setCompaniesCostData([]);
                setTotalCostCount(0);
            }
        };

        fetchCompanies();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    return {
        isCostLoading: isLoading,
        totalCostCount,
        companiesCostData,
    };
};
